import React, {useState, useEffect} from 'react'
import { MenuIcon } from '../icons'
import { Logo, profile } from '../images';
import LogoutButton from '../helper/LogoutButton';
import { Link } from 'react-router-dom';
import { AuthData } from '../../provider/AuthProvider';
import { RenderMenu } from './RenderMenu';
import { nav } from './Navs';   
import { MdEdit, MdSettings, MdLogout, MdClose, MdMenu, MdStar } from 'react-icons/md';
import { FaBell, FaTimes, FaBars } from 'react-icons/fa';

const Header = ({sidenav, toggleSidenav}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isProfileOpen, setProfileOpen] = useState(false);
    const [activeLink, setActiveLink] = useState("/explore");
    const { user } = AuthData();
    
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }
    
    const toggleProfileMenu = () => {
        setProfileOpen(!isProfileOpen);
    }
    
    const handleMenuClick = (path) => {
        console.log(path);
        setActiveLink(path);
        setIsMenuOpen(false); // Close mobile menu when item is clicked
    }

    // Close menus when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.profile-menu') && !event.target.closest('.profile-button')) {
                setProfileOpen(false);
            }
            if (!event.target.closest('.mobile-menu') && !event.target.closest('.menu-button')) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(()=>{
        console.log(user)
    }, [user])

    const MenuItem = ({r, isMobile = false}) => {
        return(
            <div className={isMobile ? "w-full" : ""}>
                <Link 
                    onClick={() => handleMenuClick(r.path)} 
                    to={r.path} 
                    className={`${isMobile 
                        ? 'block w-full px-4 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-600 border-b border-gray-100 last:border-b-0' 
                        : 'hover:border-orange-500 hover:underline hover:underline-offset-8 decoration-2 hover:text-orange-500'
                    } ${activeLink === r.path ? 'text-orange-500 underline underline-offset-8': ''}`}
                >
                    {r.name}
                </Link>
            </div>
        )
    }

    const DesktopMenu = () => (
        <div className="gap-3 hidden lg:flex items-center">
            {nav.map((r,i)=>{
                if(!r.isPrivate && r.isMenu){
                    return(
                        <MenuItem key={i} r={r}/>
                    )
                }else if (user?.isAuthenticated && r.isMenu ){
                    return(
                        <MenuItem key={i} r={r}/>
                    )
                }else return false
            })}
            {!user?.isAuthenticated && (
                <>
                <div><Link to='/about' className='hover:border-orange-500 hover:underline hover:underline-offset-8 decoration-2 hover:text-orange-500'>About</Link></div>
                <div><Link to='/faq' className='hover:border-orange-500 hover:underline hover:underline-offset-8 decoration-2 hover:text-orange-500'>FAQs</Link></div>
                </>
            )}     
        </div>
    );

    const MobileMenu = () => (
        <div className={`mobile-menu lg:hidden fixed inset-0 z-50 transform transition-transform duration-300 ease-in-out ${
            isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}>
            {/* Backdrop */}
            <div 
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={() => setIsMenuOpen(false)}
            />
            
            {/* Menu Panel */}
            <div className="fixed right-0 top-0 h-full w-80 max-w-sm bg-white shadow-xl">
                {/* Menu Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                        <img src={Logo} className="h-6 w-6" alt='Logo' />
                        <span className="text-lg font-semibold">
                            <span className='text-orange-500'>Oodles </span>Internships
                        </span>
                    </div>
                    <button
                        onClick={() => setIsMenuOpen(false)}
                        className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md"
                    >
                        <FaTimes className="h-5 w-5" />
                    </button>
                </div>

                {/* User Profile Section (Mobile) */}
                {user?.isAuthenticated && (
                    <div className="p-4 border-b border-gray-200 bg-gray-50">
                        <div className="flex items-center space-x-3">
                            <img src={profile} className='h-12 w-12 rounded-full border-2 border-orange-200'/>
                            <div>
                                <p className="font-medium text-gray-900">{user?.userd?.displayName}</p>
                                <p className="text-sm text-gray-600">Intern</p>
                                {user?.profile?.internID && (
                                    <p className="text-xs text-orange-600 font-mono">{user.profile.internID}</p>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Navigation Links */}
                <div className="flex-1 overflow-y-auto">
                    <nav className="py-2">
                        {nav.map((r,i)=>{
                            if(!r.isPrivate && r.isMenu){
                                return(
                                    <MenuItem key={i} r={r} isMobile={true}/>
                                )
                            }else if (user?.isAuthenticated && r.isMenu ){
                                return(
                                    <MenuItem key={i} r={r} isMobile={true}/>
                                )
                            }else return false
                        })}
                        
                        {!user?.isAuthenticated && (
                            <>
                            <Link 
                                to='/about' 
                                onClick={() => setIsMenuOpen(false)}
                                className='block w-full px-4 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-600 border-b border-gray-100'
                            >
                                About
                            </Link>
                            <Link 
                                to='/faq' 
                                onClick={() => setIsMenuOpen(false)}
                                className='block w-full px-4 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-600 border-b border-gray-100'
                            >
                                FAQs
                            </Link>
                            </>
                        )}
                    </nav>
                </div>

                {/* User Actions (Mobile) */}
                {user?.isAuthenticated && (
                    <div className="border-t border-gray-200 p-4 space-y-2">
                        <Link
                            to="/profile"
                            onClick={() => setIsMenuOpen(false)}
                            className="flex items-center justify-between w-full px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
                        >
                            <span>Edit Profile</span>
                            <MdEdit className='h-5 w-5'/>
                        </Link>
                        <Link
                            to="/settings"
                            onClick={() => setIsMenuOpen(false)}
                            className="flex items-center justify-between w-full px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
                        >
                            <span>Settings</span>
                            <MdSettings className='h-5 w-5'/>
                        </Link>
                        <LogoutButton 
                            AuthData={AuthData} 
                            style="flex items-center justify-between w-full px-3 py-2 text-red-600 hover:bg-red-50 rounded-md border-t pt-2 mt-2"
                        />
                    </div>
                )}

                {/* Login/Signup for non-authenticated users (Mobile) */}
                {!user?.isAuthenticated && (
                    <div className="border-t border-gray-200 p-4 space-y-2">
                        <Link
                            to="/main-signup"
                            onClick={() => setIsMenuOpen(false)}
                            className="block w-full bg-orange-500 hover:bg-orange-600 text-white text-center py-2 px-4 rounded-md font-medium"
                        >
                            Sign Up Now!
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <header className='fixed top-0 left-0 right-0 border-b-2 bg-white z-50 shadow-sm'>
            <div className='px-4 sm:px-6 lg:px-24 py-2'>
                <div className='flex flex-row justify-between items-center'>
                    {/* Logo side */}
                    <div className='flex gap-2 items-center'>
                        <img src={Logo} className="h-8 w-8" alt='Logo' />
                        <Link to={user?.isAuthenticated ? "/explore" : "/"} className='no-underline'>
                            <p className='hover:text-gray-600 text-xl sm:text-2xl font-medium'>
                                <span className='text-orange-500'>Oodles </span>
                                <span className="hidden sm:inline">Internships</span>
                                <span className="sm:hidden">Int.</span>
                            </p>
                        </Link>
                    </div>

                    {/* Desktop Menu */}
                    <DesktopMenu />

                    {/* Right side - Desktop Profile + Mobile Menu Button */}
                    <div className="flex items-center space-x-3">
                        {/* Desktop Profile & Notifications */}
                        {user?.isAuthenticated && (
                            <div className='items-center gap-4 hidden lg:flex'>
                                {/* Notifications */}
                                <button className="p-2 text-gray-600 hover:text-orange-500 hover:bg-orange-50 rounded-md transition-all duration-200">
                                    <FaBell className="w-5 h-5" />
                                </button>
                                
                                {/* Profile Dropdown */}
                                <div className="relative">
                                    <button 
                                        onClick={toggleProfileMenu}
                                        className="profile-button flex gap-2 items-center py-2 px-3 rounded-xl hover:bg-gray-50 transition-colors"
                                    >
                                        <div className='flex items-center'>
                                            <div className='flex gap-2 items-center'>
                                                <img src={profile} className='h-9 w-9 rounded-full border-2 border-gray-200'/>
                                                <div className='flex flex-col items-start'>
                                                    <p className="font-medium text-gray-900 truncate max-w-24">
                                                        {user?.userd?.displayName?.split(' ')[0] || 'User'}
                                                    </p>
                                                    <p className='text-xs text-gray-500'>Intern</p>
                                                </div>
                                            </div>
                                        </div>
                                        <svg 
                                            className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${isProfileOpen ? 'rotate-180' : ''}`}
                                            xmlns="http://www.w3.org/2000/svg" 
                                            viewBox="0 0 24 24" 
                                            fill="currentColor"
                                        >
                                            <path d="M12 16l-6-6h12z" />
                                        </svg>
                                    </button>
                                       
                                    {isProfileOpen && (
                                        <div className='profile-menu absolute right-0 top-full mt-2 w-52 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-50'>
                                            <div className='py-1'>
                                                <Link
                                                    onClick={toggleProfileMenu}
                                                    to="/profile"
                                                    className="flex justify-between items-center px-4 py-3 text-gray-700 hover:bg-gray-50"
                                                >
                                                   <span>Edit Profile</span>
                                                   <MdEdit className='h-5 w-5 text-gray-400'/>
                                                </Link>
                                                <Link
                                                    onClick={toggleProfileMenu}
                                                    to="/settings"
                                                    className="flex justify-between items-center px-4 py-3 text-gray-700 hover:bg-gray-50"
                                                >
                                                    <span>Settings</span>
                                                    <MdSettings className='h-5 w-5 text-gray-400'/>
                                                </Link>
                                                <div className="border-t border-gray-100 mt-1 pt-1">
                                                    <LogoutButton 
                                                        AuthData={AuthData} 
                                                        style="flex justify-between items-center w-full px-4 py-3 text-red-600 hover:bg-red-50 text-left"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}  
                                </div>
                            </div>
                        )}

                        {/* Desktop Login/Signup for non-authenticated users */}
                        {!user?.isAuthenticated && (
                            <div className="hidden lg:flex items-center space-x-3">
                                <Link
                                    to="/main-signup"
                                    className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md font-medium transition-colors"
                                >
                                    Sign Up Now!
                                </Link>
                            </div>
                        )}

                        {/* Mobile Menu Button */}
                        <button
                            onClick={toggleMenu}
                            className="menu-button lg:hidden p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
                        >
                            {isMenuOpen ? (
                                <FaTimes className="h-6 w-6" />
                            ) : (
                                <FaBars className="h-6 w-6" />
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            <MobileMenu />
        </header>
    )
}

export default Header